import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    // console.log("search text", searchText);
    if(!items) return [];
    if(!searchText) return items;

searchText = searchText.toLowerCase();

return items.filter( it => {
  // console.log(it);
      return it.num_doc_compras;
    });
   }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts